import { SVGProps } from "react";

export default function ConvertIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, fill = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.5177 3.67812H4.49271L6.05938 2.11146C6.30104 1.86979 6.30104 1.46979 6.05938 1.22813C5.81771 0.986458 5.41771 0.986458 5.17604 1.22813L2.54271 3.86146C2.48438 3.91979 2.44271 3.98646 2.40938 4.06146C2.37604 4.13646 2.35938 4.21979 2.35938 4.30312C2.35938 4.38646 2.37604 4.46979 2.40938 4.54479C2.44271 4.61979 2.48438 4.68646 2.54271 4.74479L5.17604 7.37813C5.30104 7.50313 5.45937 7.56146 5.61771 7.56146C5.77604 7.56146 5.93438 7.50313 6.05938 7.37813C6.30104 7.13646 6.30104 6.73646 6.05938 6.49479L4.49271 4.92812H14.5177C15.551 4.92812 16.3927 5.76979 16.3927 6.80312V9.56979C16.3927 9.91146 16.676 10.1948 17.0177 10.1948C17.3594 10.1948 17.6427 9.91146 17.6427 9.56979V6.80312C17.6427 5.07812 16.2427 3.67812 14.5177 3.67812Z"
        fill={fill}
      />
      <path
        d="M17.6427 15.6964C17.6427 15.613 17.626 15.5297 17.5927 15.4547C17.5594 15.3797 17.5177 15.313 17.4594 15.2547L14.826 12.6214C14.5844 12.3797 14.1844 12.3797 13.9427 12.6214C13.701 12.863 13.701 13.263 13.9427 13.5047L15.5094 15.0714H5.48438C4.45104 15.0714 3.60938 14.2297 3.60938 13.1964V10.4297C3.60938 10.088 3.32604 9.80469 2.98438 9.80469C2.64271 9.80469 2.35938 10.088 2.35938 10.4297V13.1964C2.35938 14.9214 3.75937 16.3214 5.48438 16.3214H15.5094L13.9427 17.888C13.701 18.1297 13.701 18.5297 13.9427 18.7714C14.0677 18.8964 14.226 18.9547 14.3844 18.9547C14.5427 18.9547 14.701 18.8964 14.826 18.7714L17.4594 16.138C17.5177 16.0797 17.5594 16.013 17.5927 15.938C17.626 15.863 17.6427 15.7797 17.6427 15.6964Z"
        fill={fill}
      />
    </svg>
  );
}
